import { Avatar, Divider } from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import * as React from 'react';

import type { ChangeHistoryContentItem } from 'v2/interfaces/productChangeHistory';

import { useStyles } from './styles';

type ChangeHistoryItemProps = {
  content: ChangeHistoryContentItem;
  onOpenDetails: (data: ChangeHistoryContentItem) => void;
};

export const ChangeHistoryItem = ({ content, onOpenDetails }: ChangeHistoryItemProps) => {
  const classes = useStyles();

  const accountDescription = () => {
    if (content.isChangedBySupport) return 'Via Suporte Eduzz';
    if (content.isChangedByProducer) return 'Titular da conta';
    return 'Via controle de acesso';
  };

  const formatDate = (dateRaw: string) => new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'medium' }).format(new Date(dateRaw));

  return (
    <>
      <div className={classes.itemWrapper} onClick={() => onOpenDetails(content)}>
        <div className={classes.itemAvatar}>
          <Avatar src={content.customerPhoto} alt={content.customerNameWhoModified} />
          <div className={classes.itemDescription}>
            <div>{formatDate(content.historyCreatedAt)}</div>
            <div>
              {content.customerNameWhoModified}{' '}
              <span className={classes.itemAccountDescription}>
                {accountDescription()} - {content.customerEmail}
              </span>
            </div>
          </div>
        </div>
        <div>
          <ChevronRightIcon />
        </div>
      </div>
      <Divider variant='middle' className={classes.itemDivider} />
    </>
  );
};
